<button type="button" class="btn btn-primary"
        popover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
  Preconfigured popover
</button>
